import { ActionType } from "./actions.js";
import { changeDDLScriptAction, changeShowAction, changeZoomLevelAction, scrollToAction, streamScrollToAction, streamZoomLevelAction } from "./atom.actions.js";
//#region src/engine/modules/settings/history.ts
var MOVE_MIN = 20;
var scrollTo = (undoActions, _, { settings }) => {
	undoActions.push(scrollToAction({
		originX: settings.originX,
		originY: settings.originY
	}));
};
var changeShow = (undoActions, { payload: { show, value } }) => {
	undoActions.push(changeShowAction({
		show,
		value: !value
	}));
};
var changeZoomLevel = (undoActions, _, { settings }) => {
	undoActions.push(changeZoomLevelAction({ value: settings.zoomLevel }));
};
var changeDDLScript = (undoActions, { payload: { position } }, { settings }) => {
	undoActions.push(changeDDLScriptAction({
		position,
		value: settings.ddlScripts[position]
	}));
};
var settingsPushUndoHistoryMap = {
	[ActionType.scrollTo]: scrollTo,
	[ActionType.changeShow]: changeShow,
	[ActionType.changeZoomLevel]: changeZoomLevel,
	[ActionType.changeDDLScript]: changeDDLScript
};
var streamScrollTo = (undoActions, redoActions, actions) => {
	const streamScrollToActions = actions.filter((action) => action.type === streamScrollToAction.type);
	if (!streamScrollToActions.length) return;
	const { x, y } = streamScrollToActions.reduce((acc, { payload: { movementX, movementY } }) => {
		acc.x += movementX;
		acc.y += movementY;
		return acc;
	}, {
		x: 0,
		y: 0
	});
	if (Math.abs(x) + Math.abs(y) < MOVE_MIN) return;
	undoActions.push(streamScrollToAction({
		movementX: -1 * x,
		movementY: -1 * y
	}));
	redoActions.push(streamScrollToAction({
		movementX: x,
		movementY: y
	}));
};
var streamZoomLevel = (undoActions, redoActions, actions) => {
	const streamZoomLevelActions = actions.filter((action) => action.type === streamZoomLevelAction.type);
	if (!streamZoomLevelActions.length) return;
	const acc = streamZoomLevelActions.reduce((acc, { payload: { value } }) => acc + value, 0);
	undoActions.push(streamZoomLevelAction({ value: -1 * acc }));
	redoActions.push(streamZoomLevelAction({ value: acc }));
};
var settingsPushStreamHistoryMap = {
	[ActionType.streamScrollTo]: streamScrollTo,
	[ActionType.streamZoomLevel]: streamZoomLevel
};
//#endregion
export { settingsPushStreamHistoryMap, settingsPushUndoHistoryMap };
